import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["thresholdsContainer", "thresholdRow", "thresholdTemplate", "emptyMessage", "stepSizeRow", "position", "positionBadge", "destroyField", "maxValue", "stepSize", "thresholdMin", "thresholdMax"]

  connect() {
    this.syncScaleLimits()
  }

  addThreshold() {
    const template = this.thresholdTemplateTarget.innerHTML
    const uniqueId = new Date().getTime()
    const newRow = template.replace(/NEW_RECORD/g, uniqueId)

    if (this.hasEmptyMessageTarget) {
      this.emptyMessageTarget.style.display = "none"
    }

    this.thresholdsContainerTarget.insertAdjacentHTML("beforeend", newRow)
    this.updatePositions()
    this.syncScaleLimits()
  }

  removeThreshold(event) {
    const row = event.target.closest("[data-scale-form-target='thresholdRow']")
    if (!row) return

    const destroyField = row.querySelector("[data-scale-form-target='destroyField']")
    if (destroyField && destroyField.name.includes("[id]") !== false) {
      // Existing record - mark for destruction
      destroyField.value = "1"
      row.style.display = "none"
    } else {
      // New record - just remove from DOM
      row.remove()
    }

    this.updatePositions()
  }

  nudgeModeChanged(event) {
    if (this.hasStepSizeRowTarget) {
      this.stepSizeRowTarget.style.display = event.target.value === "tier" ? "none" : ""
    }
  }

  maxValueChanged() {
    this.syncScaleLimits()
  }

  syncScaleLimits() {
    if (!this.hasMaxValueTarget) return

    const scaleMax = Math.max(1, parseInt(this.maxValueTarget.value, 10) || 1)

    if (this.hasStepSizeTarget) {
      this.stepSizeTarget.max = scaleMax
      const stepSize = parseInt(this.stepSizeTarget.value, 10)
      if (!Number.isNaN(stepSize) && stepSize > scaleMax) {
        this.stepSizeTarget.value = scaleMax
      }
    }

    this.thresholdMinTargets.forEach((field) => {
      field.max = scaleMax
    })

    this.thresholdMaxTargets.forEach((field) => {
      field.max = scaleMax
    })
  }

  updatePositions() {
    const visibleRows = this.thresholdRowTargets.filter(row => row.style.display !== "none")
    visibleRows.forEach((row, index) => {
      const positionField = row.querySelector("[data-scale-form-target='position']")
      const positionBadge = row.querySelector("[data-scale-form-target='positionBadge']")
      if (positionField) positionField.value = index
      if (positionBadge) positionBadge.textContent = index + 1
    })
  }
}
